export type stagesType = "development" | "production";

export const STAGE = (process.env.REACT_APP_STAGE ||
  "development") as stagesType;

export const API_URL = process.env.REACT_APP_API_URL || "default";

export const appId = process.env.REACT_APP_PRIVY_APP_ID as string;
export const clientId = process.env.REACT_APP_PRIVY_CLIENT_ID as string;
export const referralRewardMultiplicator = process.env
  .REACT_APP_REFERRER_REWARD_MULTIPLICATOR as string;
